import type { EligibilityQuestionnaire } from '@/components/questionnaire/types'
import { partnerQuestionnaireModules } from './partnerQuestionnaires.generated'

function getPartnerQuestionnaireModuleKey(partnerId: string): string {
  return `./${partnerId.trim()}-questionnaire.json`
}

export function getQuestionnaireSkuList(questionnaire: EligibilityQuestionnaire): string[] {
  const skuList = questionnaire.skuList
  if (!Array.isArray(skuList)) return []

  return skuList.map((sku) => sku.trim()).filter(Boolean)
}

function questionnaireMatchesSku(
  questionnaire: EligibilityQuestionnaire,
  sku: string | null | undefined,
): boolean {
  const skuList = getQuestionnaireSkuList(questionnaire)
  if (skuList.length === 0) return true

  const trimmedSku = sku?.trim()
  if (!trimmedSku) return false

  return skuList.includes(trimmedSku)
}

export function getPartnerEligibilityQuestionnaire(
  partnerId: string,
): EligibilityQuestionnaire | null {
  return partnerQuestionnaireModules[getPartnerQuestionnaireModuleKey(partnerId)] ?? null
}

export function resolveEligibilityQuestionnaire(
  partnerId: string | null | undefined,
  sku?: string | null,
): EligibilityQuestionnaire | null {
  if (process.env.NEXT_PUBLIC_ELIGIBILITY_QUESTIONNAIRE === 'test') {
    return partnerQuestionnaireModules[getPartnerQuestionnaireModuleKey('test')] ?? null
  }

  if (!partnerId?.trim()) return null

  const questionnaire = getPartnerEligibilityQuestionnaire(partnerId)
  if (!questionnaire) return null

  if (!questionnaireMatchesSku(questionnaire, sku)) return null

  return questionnaire
}

export function partnerEligibilityQuestionnaireRequiresSku(
  partnerId: string | null | undefined,
): boolean {
  if (process.env.NEXT_PUBLIC_ELIGIBILITY_QUESTIONNAIRE === 'test') return false
  if (!partnerId?.trim()) return false

  const questionnaire = getPartnerEligibilityQuestionnaire(partnerId)
  if (!questionnaire) return false

  return getQuestionnaireSkuList(questionnaire).length > 0
}

export function isPartnerEligibilityQuestionnaireResolved(
  kitPartnerId: string | undefined | null,
  kitSku?: string | null,
  options?: { hasFinishedKitValidationLookup?: boolean },
): boolean {
  if (process.env.NEXT_PUBLIC_ELIGIBILITY_QUESTIONNAIRE === 'test') return true
  if (!kitPartnerId?.trim()) return false

  if (partnerEligibilityQuestionnaireRequiresSku(kitPartnerId)) {
    if (kitSku?.trim()) return true
    return options?.hasFinishedKitValidationLookup === true
  }

  return true
}
